import { InfiniteLandingGlowLineBase } from './InfiniteLandingGlowLineBase'

const FEATURE_ITEMS = [
  {
    title: 'One-on-One portfolio management',
    description: 'From allocation to execution to rebalancing.',
    icon: '/images/infinite/solves/Management.png'
  },
  {
    title: 'Integrated Goal Planning',
    description: 'Aligned to all your life goals, not just market cycles.',
    icon: '/images/infinite/solves/Goal.png'
  },
  {
    title: 'Tax-aware decisions',
    description: 'So your returns aren’t lost to inefficiency.',
    icon: '/images/infinite/solves/TAX.png'
  },
  {
    title: 'End-to-end execution support',
    description: 'Built around your capital, goals and timelines.',
    icon: '/images/infinite/solves/Execution.png'
  }
]

export const InfiniteLandingKeyFeatures = () => {
  return (
    <div className='bg-black px-7 pb-14 pt-16'>
      <div className='text-center'>
        <h2 className='font-libre-caslon text-[24px] leading-[1.16] tracking-[-0.52px] text-white'>
          Solve this and more,
          <br />
          with PowerUp Infinite
        </h2>
      </div>
      <div className='mt-8 flex justify-center'>
        <div className='h-[38.892px] w-[320px] overflow-hidden'>
          <InfiniteLandingGlowLineBase />
        </div>
      </div>
      <div className='mt-5 space-y-9'>
        {FEATURE_ITEMS.map((item) => (
          <div key={item.title} className='flex items-start gap-5 justify-center'>
            <div className='mt-[2px] flex size-[72px] shrink-0 items-center justify-center rounded-[10px]'>
              <img src={item.icon} alt={item.title} className='size-[76px] object-contain' />
            </div>
            <div className='pt-[2px]'>
              <p className='max-w-[230px] font-libre-franklin text-[15px] font-medium leading-[1.24] tracking-[-0.15px] text-white'>
                {item.title}
              </p>
              <p className='mt-[10px] max-w-[230px] font-libre-franklin text-[13px] leading-[1.28] tracking-[-0.13px] text-[#5F6772]'>
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
